import {
  DailyAppointments,
  MerchantService,
} from "@/services/appointment/type";
import { Hour } from "../type";

export const getHourlyAppointments = (
  data: DailyAppointments,
  merchantServices: MerchantService[]
): Hour[] => {
  console.log(data);
  console.log(merchantServices);
  const updatedHours: Hour[] = Array.from({ length: 24 }, (_, i) => ({
    id: i,
    title: `${i}:00`,
    appointments: [],
  }));

  // data?.dailyServiceItems?.forEach((service: any) => {
  //   service?.appointments?.forEach((appointment: any) => {
  //     const appointmentDate = new Date(appointment?.appointmentDate || "");
  //     const appointmentHour = appointmentDate.getHours();
  //     const appointmentMinutes = appointmentDate.getMinutes();

  //     const hourBlock = updatedHours.find(
  //       (hour) => hour.id === appointmentHour
  //     );

  //     if (hourBlock) {
  //       const item: Appointment = {
  //         id: appointment?.id || 0,
  //         customerName: `${appointment?.customerFirstName} ${appointment?.customerLastName}`,
  //         description: appointment?.description || "",
  //         time: `${appointmentHour}:${
  //           appointmentMinutes < 10 ? "0" : ""
  //         }${appointmentMinutes}`,
  //         serviceName: service?.merchantService || "",
  //         color:
  //           merchantServices.find((x) => x.id === service?.merchantServiceId)
  //             ?.color || "",
  //       };
  //       hourBlock?.appointments?.push(item);
  //     }
  //   });
  // });

  return updatedHours;
};
